<template><div><h1>VUX V2.7.9 发布日志</h1>
<h2><a href="/zh-CN/components/clocker.html">Clocker</a></h2>
<ul><li>[fix] 修复更新值为非空时报错问题 #2449</li>
</ul>
<h2><a href="/zh-CN/components/panel.html">Panel</a></h2>
<ul><li>[fix] footer.title 为空时隐藏 footer #2476</li>
</ul>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[fix] 修正 itemClass 拼写错误 #2457</li>
</ul>
<h2><a href="/zh-CN/components/rater.html">Rater</a></h2>
<ul><li>[feature] prop:min 增加最小值 #2439</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[enhance] 支持中国联通手机号166号段</li>
</ul>
<h2><a href="/zh-CN/components/bus.html">Bus</a></h2>
<ul><li>[fix] bus 挂载到 this.$vux</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.9 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.9-267.vue?42d07edc